<template>
  <div>
    <template v-if="!loading">
      <v-app-bar flat color="transparent" class="main-appbar">
        <app-bar-nav-icon />
        <v-toolbar-title class="breadcrumbs d-flex align-center">
          <v-icon class="text-light-blue">{{ mdiChevronLeft }}</v-icon>
          <router-link class="text-decoration--none" :to="{ name: 'companies' }"
            >Companies</router-link
          >
        </v-toolbar-title>
      </v-app-bar>
      <div class="mx-4">
        <transition name="fade" mode="out-in">
          <div class="py-4">
            <div class="display-2 font-weight-bold my-6 text-capitalize">
              {{ company.name }}
            </div>
            <h3 class="mb-4">Basic Details</h3>
            <v-form ref="form" @submit.prevent="updateDetails">
              <v-row>
                <v-col md="6" sm="12" xs="12">
                  <v-text-field
                    outlined
                    flat
                    large
                    label="Company Name"
                    v-model="companyForm.name"
                    :error-messages="companyForm.$getError('name')"
                  />
                  <v-textarea
                    outlined
                    flat
                    rows="3"
                    label="Short Description"
                    v-model="companyForm.description"
                    :error-messages="companyForm.$getError('description')"
                  />
                </v-col>
              </v-row>
              <v-btn
                depressed
                large
                :loading="companyForm.$busy"
                class="text-capitalize"
                color="primary"
                type="submit"
              >
                Update
              </v-btn>
            </v-form>
            <v-snackbar v-model="snackBar.show" :right="true">
              {{ snackBar.message }}
              <v-btn color="primary" text @click="snackBar.show = false">
                Close
              </v-btn>
            </v-snackbar>
          </div>
        </transition>
      </div>
    </template>

    <loader v-model="loading" />
  </div>
</template>
<script>
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ControlsMixin from '@/utils/mixins/Controls'
import { mapState, mapActions } from 'vuex'
import Loader from '@/components/shared/Loader'
import Form from '@/utils/form'
import { pick } from 'lodash'
import Company from '@/models/Company'
import { mdiChevronLeft } from '@mdi/js'

export default {
  mixins: [ControlsMixin],

  components: {
    AppBarNavIcon,
    Loader
  },
  data() {
    return {
      loading: false,
      snackBar: {
        show: false,
        message: ''
      },
      companyForm: new Form({
        name: '',
        description: ''
      }),
      blockStateLoading: false,
      mdiChevronLeft
    }
  },
  computed: {
    ...mapState({
      company: state => state.company.selected
    })
  },
  created() {
    this.getCompany()
  },

  methods: {
    ...mapActions({
      getSelectedCompany: 'company/getSelectedCompany'
    }),

    async getCompany() {
      this.loading = true
      await this.getSelectedCompany(this.$route.params.id)
      this.companyForm = new Form(
        pick(this.company, ['id', 'name', 'description', 'address'])
      )
      this.hideLoader()
    },

    hideLoader() {
      setTimeout(() => {
        this.loading = false
      }, 300)
    },

    async updateDetails() {
      this.companyForm.$busy = true
      let payload = this.companyForm.$data()

      try {
        await new Company(payload).save()
        this.$store.commit('company/setSelectedCompany', {
          ...this.company,
          ...payload
        })
        this.snackBar.message = 'Company successfully updated!'
        this.snackBar.show = true
      } catch (err) {
        if (err.response && err.response.status === 422) {
          this.companyForm.$setErrors(err.response.data.errors)
        }
      } finally {
        this.companyForm.$busy = false
      }
    }
  }
}
</script>
